import * as types from './mutation-types'

const state = {
  loading: true,
  loadMenu: false,
  contentLoading: true,
  resMessage: '',
  user: {}
}

const getters = {
  getLoading: state => state.loading,
  getLoadMenu: state => state.loadMenu,
  getContentLoading: state => state.contentLoading,
  getResMessage: state => state.resMessage,
  getUser: state => state.user
}

const actions = {
  //将权限控制置为false
  updateLoading ({ commit }, info) {
    commit(types.PAGE_LOADING, info)
  },
  //将获取菜单设置
  updateLoadMenu ({ commit }, info) {
    commit(types.MENU_LOADING, info)
  },
  updateContentLoad ({ commit }, info) {
    commit(types.UPDATE_CONTENT_LOADING, info)
  },
  updateResMessage ({ commit }, info) {
    commit(types.UPDATE_RES_MESSAGE, info)
  },
  updateUser ({ commit }, info) {
    commit(types.UPDATE_USER, info)
  },
}

const mutations = {
  [types.PAGE_LOADING] (state, info) {
    state.loading = info
  },
  [types.MENU_LOADING] (state, info) {
    state.loadMenu = info
  },
  [types.UPDATE_CONTENT_LOADING] (state, info) {
    state.contentLoading = info
  },
  [types.UPDATE_RES_MESSAGE] (state, info) {
    state.resMessage = info
  },
  [types.UPDATE_USER] (state, info) {
    state.user = info
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}